import assignValue from "./_assignValue.js";
import baseAssignValue from "./_baseAssignValue.js";
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  for (var index = -1, length = props.length; ++index < length; ) {
    var key = props[index], newValue = void 0;
    newValue === void 0 && (newValue = source[key]), isNew ? baseAssignValue(object, key, newValue) : assignValue(object, key, newValue);
  }
  return object;
}
export {
  copyObject as default
};
//# sourceMappingURL=_copyObject.js.map
